import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import authorized from '../../../authorized';
import { Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Layout from '../../ui/Layout';

class ResetYourPasswordSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = { notification: false };
  }
  componentDidMount() {
    this.showNotification = setInterval(
      () => this.setState({ notification: true }),
      500
    );
  }
  componentWillUnmount() {
    clearInterval(this.showNotification);
  }
  render() {
    const { user, error, location, postLogin } = this.props;
    const { notification } = this.state;
    clearInterval(this.showNotification);
    setTimeout(
      () => {
        this.setState({ notification: false });
      },
      5500
    );
    return (
      <Layout route="reset-password-success">
        <Link
          className={`notification ${notification ? 'show' : 'hide'}`}
          to="/update-password"
        >
          <span>now</span>
          <div className="app">Mail</div>
          <strong>Crow's Nest™ App</strong>
          <div className="subject">Reset Your Password</div>
          <div className="preview">
            Someone requested to reset the password to your…
          </div>
        </Link>
        <Row className="justify-content-sm-center">
          <Col sm>
            <div className="icon" />
            <h2>Check your email</h2>
            <p>
              A link to reset your password has been sent to gmcgovern@redcross.org.
            </p>
            <Link to="/login" className="btn">Back to log in</Link>
          </Col>
        </Row>
        <Link className="continue" to="/update-password">
          Continue with demo →
        </Link>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    result: user,
    error
  } = state.login.toJS();
  return {
    user,
    error
  };
};
const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postLogin: fetchDux.login.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ResetYourPasswordSuccess);
